import React, { Component, } from "react"
import {
   FaCalendar,
} from 'react-icons/fa';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Grid from '@mui/material/Grid';
import TablePagination from "@mui/material/TablePagination";
import {
   Button,
   Typography,
   Box,
   Accordion,
   AccordionSummary,
   AccordionDetails
} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import FormControl from '@mui/material/FormControl';
import { DateTimePicker } from "react-rainbow-components";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import SnackbarAlert from '../common/SnackbarAlert';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { PiFolderDashed } from "react-icons/pi";
import { PiFileDashedThin } from "react-icons/pi";
import { PiMagnifyingGlass } from "react-icons/pi";
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import PageSkeletonPromoCodes from '../common/skeletons/PageSkeletonPromoCodes';
import { apiRequest } from "../../utils/apiRequest";


const paths = require('../../paths.json');

const LightTooltip = styled(({ className, ...props }) => (
   <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
   [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#222222 !important',
      color: '#ffffff',
      boxShadow: theme.shadows[1],
      fontSize: 11,
      margin: '0px'
   },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
   [`&.${tableCellClasses.head}`]: {
      padding: '16px 20px',
      textAlign: 'left',
      fontSize: '14px',
      fontWeight: '600',
      color: '#222222',

      backgroundColor: '#fff',
      // borderBottom: '1px solid #E4EBF6',
      fontFamily: 'Roboto',
   },
   [`&.${tableCellClasses.body}`]: {
      whiteSpace: 'nowrap',
      padding: '16px 20px',
      textAlign: 'left',
      fontSize: '14px',
      backgroundColor: '#fff',
      // borderBottom: '1px solid #E4EBF6',
      color: '#222222',
      fontWeight: '500',
      borderBottom: 'none',
   },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
   '&:hover': {
      backgroundColor: '#F5F9FF',
   },
   // hide last border
   '&:last-child td, &:last-child th': {
      borderBottom: 'none',
   },
}));

function toUTCDate(date) {
   if (date !== '') {
      return (new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000).toISOString()).split('.')[0]
   } else {
      return date
   }
}

const DEMO_COUPONS = [
   {
      code: 'SUMMER2024',
      discount: '25',
      duration: '3',
      end_date: '2024-08-31',
      n_redeems: 45,
      redeem_limit: 100
   },
   {
      code: 'WELCOME50',
      discount: '50',
      duration: '1',
      end_date: '2024-06-30',
      n_redeems: 150,
      redeem_limit: 200
   },
   {
      code: 'FLASH15',
      discount: '15',
      duration: '2',
      end_date: '2024-05-15',
      n_redeems: 75,
      redeem_limit: null
   },
   {
      code: 'WINTER30',
      discount: '30',
      duration: '6',
      end_date: '2025-01-31',
      n_redeems: 20,
      redeem_limit: 50
   },
   {
      code: 'NEWYEAR10',
      discount: '10',
      duration: '1',
      end_date: '2025-01-15',
      n_redeems: 5,
      redeem_limit: 500
   },
   {
      code: 'SPRING40',
      discount: '40',
      duration: '4',
      end_date: '2025-04-30',
      n_redeems: 60,
      redeem_limit: 150
   },
   {
      code: 'FALL25',
      discount: '25',
      duration: '3',
      end_date: '2024-11-30',
      n_redeems: 30,
      redeem_limit: 80
   },
   {
      code: 'BLACKFRIDAY',
      discount: '60',
      duration: '1',
      end_date: '2024-11-29',
      n_redeems: 200,
      redeem_limit: 300
   },
   {
      code: 'CYBERMONDAY',
      discount: '35',
      duration: '2',
      end_date: '2024-12-02',
      n_redeems: 90,
      redeem_limit: null
   },
   {
      code: 'LOYALTY20',
      discount: '20',
      duration: '12',
      end_date: '2025-03-31',
      n_redeems: 15,
      redeem_limit: 1000
   },
   {
      code: 'EARLYBIRD25',
      discount: '25',
      duration: '3',
      end_date: '2025-02-28',
      n_redeems: 35,
      redeem_limit: 120
   },
   {
      code: 'VIP50',
      discount: '50',
      duration: '6',
      end_date: '2025-06-30',
      n_redeems: 10,
      redeem_limit: 25
   },
   {
      code: 'BACK2SCHOOL',
      discount: '15',
      duration: '2',
      end_date: '2024-09-15',
      n_redeems: 80,
      redeem_limit: 200
   },
   {
      code: 'HALLOWEEN30',
      discount: '30',
      duration: '1',
      end_date: '2024-10-31',
      n_redeems: 50,
      redeem_limit: 150
   },
   {
      code: 'THANKSGIVING',
      discount: '20',
      duration: '3',
      end_date: '2024-11-28',
      n_redeems: 25,
      redeem_limit: null
   },
   {
      code: 'MIDYEAR45',
      discount: '45',
      duration: '4',
      end_date: '2025-07-31',
      n_redeems: 70,
      redeem_limit: 100
   },
   {
      code: 'FLASH48HOURS',
      discount: '40',
      duration: '1',
      end_date: '2025-03-19',
      n_redeems: 120,
      redeem_limit: 250
   },
   {
      code: 'WEEKEND20',
      discount: '20',
      duration: '2',
      end_date: '2025-03-23',
      n_redeems: 40,
      redeem_limit: 300
   },
   {
      code: 'REFERFRIEND',
      discount: '10',
      duration: '6',
      end_date: '2025-09-30',
      n_redeems: 15,
      redeem_limit: null
   },
   {
      code: 'BIRTHDAY25',
      discount: '25',
      duration: '1',
      end_date: '2025-12-31',
      n_redeems: 30,
      redeem_limit: 50
   },
   {
      code: 'SUMMERBOOST',
      discount: '35',
      duration: '3',
      end_date: '2025-08-31',
      n_redeems: 55,
      redeem_limit: 150
   },
   {
      code: 'HOLIDAYGIFT',
      discount: '30',
      duration: '2',
      end_date: '2025-12-25',
      n_redeems: 0,
      redeem_limit: 500
   },
   {
      code: 'MEMORIALDAY',
      discount: '20',
      duration: '4',
      end_date: '2025-05-26',
      n_redeems: 65,
      redeem_limit: 200
   },
   {
      code: 'LABORDAY15',
      discount: '15',
      duration: '2',
      end_date: '2025-09-01',
      n_redeems: 45,
      redeem_limit: 100
   },
   {
      code: 'ANNIVERSARY',
      discount: '55',
      duration: '6',
      end_date: '2025-10-15',
      n_redeems: 25,
      redeem_limit: 75
   }
];

class Coupons extends Component {
   constructor(props) {
      super(props);
      this.state = {
         user_coupons: [],
         page_num: 0,
         n_rows_per_page: 5,
         setCouponModal: false,
         // dateTimeStart: '',
         dateTimeEnd: '',
         couponName: '',
         discountTiers: ['5', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55', '60', '65', '70', '75', '80', '85', '90', '95', '100'],
         discountTierSelected: '',
         discountDurationMonths: ['2', '3', '6', '9', '12'],
         discountDurationSelected: '',
         couponLimit: '',
         errorMsg: '',
         successMsg: '',
         couponSuccess: false,
         snackbar: false,
         isCodeCopied: false,
         copiedIndex: null,
         isDemo: false,
         isLoading: true,
      };
      this.props.setState({ isAnyModalOpen: false })
      this.handleChangePage = this.handleChangePage.bind(this);
      this.get_and_post_data = this.get_and_post_data.bind(this);
      this.postCouponSubmit = this.postCouponSubmit.bind(this);
      this.NewCouponSubmit = this.NewCouponSubmit.bind(this);
      this.DeleteCouponSubmit = this.DeleteCouponSubmit.bind(this);
      this.postCouponDelete = this.postCouponDelete.bind(this);
      this.handleDemoToggle = this.handleDemoToggle.bind(this);
   }

   componentDidMount() {
      this.setState({ isLoading: true });
      this.get_and_post_data(
         paths.BACKEND_URL + "api/settings_page_coupon_page_info",
         'get',
      )
   }

   handleChangePage(event, newPage) {
      this.setState({ page_num: newPage })
   };

   get_and_post_data = async (...args) => {
      try {
         const result = await apiRequest.get_and_post_data(this, ...args);
         this.setState({ isLoading: false, user_coupons: result.data?.user_coupons || [] });
         return result.data;
      } catch (error) {
         this.setState({ isLoading: false });
      }
   }

   // Check Code using regex -> ^(\d|\w)+$ for only chars and numbers (no spaces or special characters)
   codeValidation() {
      const regex = /^(\d|\w)+$/;
      if (regex.test(this.state.couponName) === false) {
         this.setState({
            errorMsg: "Code can only contain numbers and letters with no spaces",
            snackbar: true,
         })
         return false;
      } else if (this.state.couponName === '') {
         this.setState({
            errorMsg: "Please enter a promotion code",
            snackbar: true,
         })
         return false;
      }
      return true;
   }


   NewCouponSubmit() {
      if (this.codeValidation()) {
         if (this.state.discountTierSelected === '') {
            this.setState({
               snackbar: true,
               errorMsg: 'You need to add a discount amount.',
            })
         } else if (this.state.discountDurationSelected === '') {
            this.setState({
               snackbar: true,
               errorMsg: 'You need to add a discount duration.',
            })
         } else {
            this.setState({ copiedIndex: null })
            const form_data = new FormData();
            form_data.append('name', this.state.couponName);
            form_data.append('discount', this.state.discountTierSelected);
            form_data.append('duration', this.state.discountDurationSelected);
            form_data.append('limit', this.state.couponLimit);
            form_data.append('end_date', toUTCDate(this.state.dateTimeEnd));
            this.get_and_post_data(
               paths.BACKEND_URL + "api/settings_submit_new_coupon",
               'post',
               form_data,
               this.postCouponSubmit,
            )
         }

      }
   }

   postCouponSubmit(res) {
      if (res.data.success === true) {
         this.setState({
            snackbar: false,
            errorMsg: '',
         })
         this.setState({
            setCouponModal: false,
            couponName: '',
            discountTierSelected: '',
            discountDurationSelected: '',
            couponLimit: '',
            dateTimeEnd: '',
         })
         this.props.setState({ isAnyModalOpen: false })
         this.get_and_post_data(
            paths.BACKEND_URL + "api/settings_page_coupon_page_info",
            'get',
         )

         this.setState({
            couponSuccess: true,
            successMsg: 'Promotion Code Created',
         })


      } else if (res.data.error) {
         this.setState({
            snackbar: true,
            errorMsg: res.data.error,
         })
      } else {
         this.setState({
            snackbar: true,
            errorMsg: 'Error, please try again. If the error persists please contact us through the help page.',
         })
      }
   }

   DeleteCouponSubmit(coupon_code) {
      this.setState({ copiedIndex: null })
      const form_data = new FormData();
      form_data.append('code', coupon_code);
      this.get_and_post_data(
         paths.BACKEND_URL + "api/settings_submit_delete_coupon",
         'post',
         form_data,
         this.postCouponDelete,
      )
   }

   postCouponDelete(res) {
      if (res.data.success === true) {
         this.setState({
            snackbar: false,
            errorMsg: '',
         })
         this.get_and_post_data(
            paths.BACKEND_URL + "api/settings_page_coupon_page_info",
            'get',
         )
      } else {
         this.setState({
            snackbar: true,
            errorMsg: 'Error, please try again. If the error persists please contact us through the help page.',
         })
      }
   }

   handleDemoToggle = () => {
      this.setState(prevState => ({
         isDemo: !prevState.isDemo,
         user_coupons: !prevState.isDemo ? DEMO_COUPONS : []
      }));

      if (this.state.isDemo) {
         this.get_and_post_data(
            paths.BACKEND_URL + "api/settings_page_coupon_page_info",
            'get',
         );
      }
   };

   render() {
      if (this.state.isLoading) {
         return (
            <>
               <Grid container sx={{ display: { xs: 'none', 'lg': 'block' } }}>
                  <Grid xs={9} sm={6}>
                  </Grid>

               </Grid>

               <PageSkeletonPromoCodes />
            </>
         )
      } else {
         let table_contents = []
         let table_content_mobile = []

         if (this.state.user_coupons && this.state.user_coupons?.length > 0) {
            table_contents = this.state.user_coupons.slice(this.state.page_num * this.state.n_rows_per_page, (this.state.page_num + 1) * this.state.n_rows_per_page).map((user_coupon, index) => {
               let duration_str = user_coupon['duration'] === '1' ? 'month' : 'months';
               let limit_str = user_coupon['redeem_limit'] ? `/${user_coupon['redeem_limit']}` : '';

               return (
                  <StyledTableRow key={'user_subscription_' + index}>
                     <StyledTableCell>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                           <span>{user_coupon['code']}</span>
                           <div style={{ display: 'flex', gap: '10px' }}>
                              <Button
                                 sx={{
                                    backgroundColor: '#F5F9FF',
                                    color: 'var(--brand-color)',
                                    fontSize: '12px',
                                    textTransform: 'none',
                                    boxShadow: 'none',
                                    padding: '2px 10px',
                                    fontWeight: '500',
                                    ':hover': {
                                       backgroundColor: 'var(--brand-color)',
                                       color: 'white',
                                    },
                                 }}
                                 onClick={() => {
                                    navigator.clipboard.writeText(user_coupon['code']);
                                    this.setState({
                                       isCodeCopied: true,
                                       copiedIndex: index,
                                       couponSuccess: true,
                                       successMsg: 'Code copied',
                                    });
                                 }}
                                 disableRipple
                              >
                                 Copy Code
                              </Button>
                              <LightTooltip title="Share this link to have the promo auto applied at checkout">
                                 <Button
                                    sx={{
                                       backgroundColor: '#F5F9FF',
                                       color: 'var(--brand-color)',
                                       fontSize: '12px',
                                       textTransform: 'none',
                                       boxShadow: 'none',
                                       padding: '2px 10px',
                                       fontWeight: '500',
                                       ':hover': {
                                          backgroundColor: 'var(--brand-color)',
                                          color: 'white',
                                       },
                                    }}
                                    onClick={() => {
                                       const domain = paths.URL;
                                       const inf = this.props.influencer;
                                       navigator.clipboard.writeText(`${domain}${inf}?promo_code=${user_coupon['code']}`);
                                       this.setState({
                                          isCodeCopied: true,
                                          copiedIndex: index,
                                          couponSuccess: true,
                                          successMsg: 'Link copied',
                                       });
                                    }}
                                    disableRipple
                                 >
                                    Copy Link
                                 </Button>
                              </LightTooltip>
                           </div>
                        </div>
                     </StyledTableCell>
                     <StyledTableCell align="left">{user_coupon['discount']}%</StyledTableCell>
                     <StyledTableCell align="left">{user_coupon['duration']} {duration_str}</StyledTableCell>
                     <StyledTableCell align="left">{user_coupon['end_date']}</StyledTableCell>
                     <StyledTableCell align="left">{user_coupon['n_redeems']}{limit_str}</StyledTableCell>
                     <StyledTableCell align="left">
                        <Button
                           sx={{
                              color: '#FF4D4D',
                              fontSize: '12px',
                              textTransform: 'none',
                              padding: '2px 10px',
                              fontWeight: '500',
                              ':hover': {
                                 backgroundColor: '#FFE5E5',
                              },
                           }}
                           onClick={() => this.DeleteCouponSubmit(user_coupon['code'])}
                        >
                           Delete
                        </Button>
                     </StyledTableCell>
                  </StyledTableRow>
               )
            })
            table_content_mobile = this.state.user_coupons.slice(this.state.page_num * this.state.n_rows_per_page, (this.state.page_num + 1) * this.state.n_rows_per_page).map((user_coupon, index) => {
               let options_button = ''
               let end_date = user_coupon['end_date']
               let duration_str = ''
               if (user_coupon['duration'] === '1') {
                  duration_str = 'month'
               } else {
                  duration_str = 'months'
               }
               let limit_str = ''
               if (user_coupon['redeem_limit']) {
                  limit_str = '/' + user_coupon['redeem_limit']
               }
               return (
                  <Grid
                     container
                     item
                     xs={12}
                  >
                     <Accordion
                        style={{
                           backgroundColor: 'var(--rebranding-content-background-color)',
                           color: '#9CA3B4',
                           width: '100%',
                           paddingRight: '40px'
                        }}
                     >
                        <AccordionSummary
                           expandIcon={<ExpandMoreIcon
                              style={{ color: 'var(--light-theme-text-color)', fontSize: '30px' }} />}
                           aria-controls="panel1a-content"
                           id="panel1a-header"
                           style={{ padding: '0px', margin: '0px 0px 0px 20px', width: '100%' }}
                        >

                           <div style={{
                              alignItems: 'center',
                              textAlign: 'center',
                              justifyContent: 'center',
                              display: 'flex'
                           }}>

                              <span style={{ color: 'var(--light-theme-text-color)', fontWeight: '600', fontSize: '16px' }}>{user_coupon['code']}</span>
                              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                 <Button sx={{
                                    backgroundColor: 'var(--brand-color)',
                                    color: '#fff',
                                    fontSize: '12px',
                                    textTransform: 'none',
                                    boxShadow: 'none',
                                    float: 'right',
                                    padding: '2px 6px',
                                    margin: '0 5px 0 20px',
                                    ':hover': {
                                       backgroundColor: 'var(--brand-color-hover)',
                                       color: 'white', boxShadow: 'none',
                                    },
                                 }}
                                    onClick={(e) => {
                                       e.stopPropagation()
                                       const domain = paths.URL
                                       const inf = this.state.current_user
                                       navigator.clipboard.writeText(`${user_coupon['code']}`)
                                       this.setState({
                                          isCodeCopied: true,
                                          copiedIndex: index,
                                          couponSuccess: true,
                                          successMsg: 'Code copied',
                                       })
                                    }}
                                    disableRipple
                                 > Copy Code

                                 </Button>
                                 <LightTooltip title="Share this link to have the promo auto applied at checkout" placement="right-start">
                                    <Button sx={{
                                       backgroundColor: 'var(--brand-color)',
                                       color: '#fff',
                                       fontSize: '12px',
                                       textTransform: 'none',
                                       boxShadow: 'none',
                                       float: 'right',
                                       padding: '2px 6px',
                                       ':hover': {
                                          backgroundColor: 'var(--brand-color-hover)',
                                          color: 'white', boxShadow: 'none',
                                       },
                                    }}
                                       onClick={(e) => {
                                          e.stopPropagation()
                                          const domain = paths.URL
                                          const inf = this.state.current_user
                                          navigator.clipboard.writeText(`${domain}${inf}?promo_code=${user_coupon['code']}`)
                                          this.setState({
                                             isCodeCopied: true,
                                             copiedIndex: index,
                                             couponSuccess: true,
                                             successMsg: 'Link copied',
                                          })
                                       }}
                                       disableRipple
                                    > Copy Link
                                    </Button>
                                 </LightTooltip>
                              </div>

                           </div>

                        </AccordionSummary>
                        <AccordionDetails>
                           <Grid container>
                              <Grid xs={12}>
                                 <Typography style={{ fontSize: '16px', fontWeight: '600', paddingTop: '10px', color: 'var(--light-theme-text-color)' }}>
                                    {user_coupon['n_redeems']}{limit_str} Redemptions
                                 </Typography>
                              </Grid>
                              <Grid xs={12}>
                                 <Typography style={{ fontSize: '16px', fontWeight: '600', paddingTop: '10px', color: 'var(--light-theme-text-color)' }}>
                                    Discount: {user_coupon['discount']}%
                                 </Typography>
                              </Grid>
                              <Grid xs={12}>
                                 <Typography style={{ fontSize: '16px', fontWeight: '600', paddingTop: '10px', color: 'var(--light-theme-text-color)' }}>
                                    Duration: {user_coupon['duration']} months
                                 </Typography>
                              </Grid>
                              <Grid xs={12}>
                                 <Typography style={{ fontSize: '16px', fontWeight: '600', paddingTop: '10px', color: 'var(--light-theme-text-color)' }}>
                                    End Date: {end_date}
                                 </Typography>
                              </Grid>
                              <Grid xs={12}>
                                 <Button class="setting_my_sub_cancel" style={{ cursor: 'pointer', float: "right" }} onClick={e => this.DeleteCouponSubmit(user_coupon['code'])}>
                                    Delete
                                 </Button>
                              </Grid>
                           </Grid>
                        </AccordionDetails>
                     </Accordion>
                  </Grid>

               )
            })
         } else {
            table_contents = []
            table_content_mobile = []
         }
         return (
            <div>
               <Grid
                  Container
                  xs={12}
                  justifyContent="center"
               >

                  <Grid
                     container
                  >
                     <Grid xs={9} sm={6} sx={{ display: { xs: 'none', 'lg': 'block' } }}>
                     </Grid>
                     <Grid xs={12} sm={6}>
                        <Button
                           disableRipple
                           variant="contained"
                           sx={{
                              backgroundColor: 'var(--brand-color)',
                              fontSize: '14px',
                              textTransform: 'none',
                              marginBottom: '20px',
                              boxShadow: 'none',
                              borderRadius: '8px',
                              fontWeight: '600',
                              float: 'right',
                              ':hover': {
                                 backgroundColor: 'var(--brand-color-hover)',
                                 color: 'white', boxShadow: 'none',
                              },
                           }}
                           type="submit"
                           value="new coupon"
                           onClick={() => {
                              this.setState({
                                 setCouponModal: true
                              });
                              this.props.setState({ isAnyModalOpen: true });
                           }}>
                           {window.innerWidth < 500 ? 'New' : 'New Promotion Code'}
                        </Button>
                     </Grid>
                  </Grid>
                  {/* Desktop */}
                  <Box
                     sx={{
                        display: { xs: 'none', 'lg': 'flex' },
                     }}
                  >
                     <Grid
                        container
                     >
                        <TableContainer
                           sx={{
                              boxShadow: 'none',
                              borderRadius: '10px',
                              border: '1px solid #E4EBF6',
                              backgroundColor: '#fff',
                              justifyContent: 'center',

                           }}>
                           <Table sx={{
                              minWidth: 650,
                              boxShadow: 'none',
                           }} size="small" aria-label="a dense table">
                              <TableHead sx={{ borderBottom: '1px solid #E4EBF6', textAlign: 'center' }}>
                                 <StyledTableRow sx={{ backgroundColor: '#fff', textAlign: 'center' }}>
                                    <StyledTableCell>Code</StyledTableCell>
                                    <StyledTableCell align="center" sx={{ textAlign: 'center' }}>Discount</StyledTableCell>
                                    <StyledTableCell align="center" sx={{ textAlign: 'center' }}>Duration</StyledTableCell>
                                    <StyledTableCell align="center" sx={{ textAlign: 'center' }}>End Date</StyledTableCell>
                                    <StyledTableCell align="center" sx={{ textAlign: 'center' }}>Redemptions</StyledTableCell>
                                    <StyledTableCell align="center" sx={{ textAlign: 'center' }}>Actions</StyledTableCell>
                                 </StyledTableRow>
                              </TableHead>
                              <TableBody >
                                 {this.state.user_coupons.length > 0 ? (
                                    table_contents
                                 ) : (
                                    <TableRow>
                                       <TableCell colSpan={6} sx={{ borderBottom: 'none' }}>
                                          <div style={{
                                             padding: '40px 0',
                                             textAlign: 'center',
                                             backgroundColor: '#fff'
                                          }}>
                                             <PiMagnifyingGlass size={48} color="#9CA3B4" style={{ padding: '10px 0px' }} />
                                             <h3 style={{
                                                marginTop: '8px',
                                                fontSize: '14px',
                                                fontWeight: '600',
                                                color: '#1D1D1D',
                                                fontFamily: 'Roboto, sans-serif'
                                             }}>No Promotion Codes</h3>
                                             <p style={{
                                                marginTop: '4px',
                                                fontSize: '14px',
                                                color: '#9CA3B4',
                                                fontFamily: 'Roboto, sans-serif',
                                                fontWeight: '500'
                                             }}>Get started by creating a new promotion code.</p>
                                          </div>
                                       </TableCell>
                                    </TableRow>
                                 )}
                              </TableBody>
                           </Table>
                        </TableContainer>
                        <TablePagination
                           component="div"
                           count={this.state.user_coupons.length}
                           page={this.state.page_num}
                           onPageChange={this.handleChangePage}
                           rowsPerPageOptions={[5]}
                           rowsPerPage={this.state.n_rows_per_page}
                           sx={{
                              '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
                                 fontSize: '14px'
                              }
                           }}
                        />
                     </Grid>
                  </Box>
                  {/* Mobile */}
                  <Box
                     sx={{
                        display: { xs: 'flex', 'lg': 'none' },
                        width: '100%',
                        marginBottom: '20px'
                     }}
                  >
                     <Grid
                        container
                        sx={{
                           '& .MuiAccordion-root': {
                              boxShadow: 'none',
                              border: '1px solid #E4EBF6',
                              marginBottom: '10px',
                              borderRadius: '8px',
                              '&:before': {
                                 display: 'none'
                              }
                           }
                        }}
                     >
                        {this.state.user_coupons.length > 0 ? (
                           this.state.user_coupons
                              .slice(
                                 this.state.page_num * this.state.n_rows_per_page,
                                 (this.state.page_num + 1) * this.state.n_rows_per_page
                              )
                              .map((user_coupon, index) => {
                                 let duration_str = user_coupon['duration'] === '1' ? 'month' : 'months';
                                 let limit_str = user_coupon['redeem_limit'] ? `/${user_coupon['redeem_limit']}` : '';

                                 return (
                                    <Grid container key={index}>
                                       <Grid xs={12}>
                                          <Accordion>
                                             <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                <Grid container alignItems="center">
                                                   <Typography sx={{ fontWeight: '600', fontSize: '12px' }}>
                                                      {user_coupon['code']}
                                                   </Typography>
                                                   <Typography sx={{ marginLeft: 'auto', fontSize: '12px', color: '#9CA3B4', fontWeight: '500' }}>
                                                      {user_coupon['n_redeems']}{limit_str} Redemptions
                                                   </Typography>
                                                </Grid>
                                             </AccordionSummary>
                                             <AccordionDetails>
                                                <Grid direction="column" spacing={1}>
                                                   <Grid sx={{ marginBottom: '10px' }}>
                                                      <Typography variant="body2" color="textSecondary" sx={{ fontSize: '14px', fontWeight: '500', color: '#222222' }}>
                                                         Discount
                                                      </Typography>
                                                      <Typography sx={{ fontSize: '12px', color: '#9CA3B4', fontWeight: '500' }}>
                                                         {user_coupon['discount']}%
                                                      </Typography>
                                                   </Grid>
                                                   <Grid sx={{ marginBottom: '10px' }}>
                                                      <Typography variant="body2" color="textSecondary" sx={{ fontSize: '14px', fontWeight: '500', color: '#222222' }}>
                                                         Duration
                                                      </Typography>
                                                      <Typography sx={{ fontSize: '12px', color: '#9CA3B4', fontWeight: '500' }}>
                                                         {user_coupon['duration']} {duration_str}
                                                      </Typography>
                                                   </Grid>
                                                   <Grid sx={{ marginBottom: '10px' }}>
                                                      <Typography variant="body2" color="textSecondary" sx={{ fontSize: '14px', fontWeight: '500', color: '#222222' }}>
                                                         End Date
                                                      </Typography>
                                                      <Typography sx={{ fontSize: '12px', color: '#9CA3B4', fontWeight: '500' }}>
                                                         {user_coupon['end_date'] || 'No end date'}
                                                      </Typography>
                                                   </Grid>
                                                   <Grid sx={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                                                      <Button
                                                         sx={{
                                                            color: '#FFFFFF',
                                                            cursor: 'pointer',
                                                            backgroundColor: 'var(--danger-color)',
                                                            fontSize: '12px',
                                                            textTransform: 'none',
                                                            padding: '2px 10px',
                                                            fontWeight: '500',
                                                            ':hover': {
                                                               backgroundColor: 'var(--danger-color-hover)',
                                                               boxShadow: 'none',
                                                            },
                                                         }}
                                                         onClick={() => this.DeleteCouponSubmit(user_coupon['code'])}
                                                      >
                                                         Delete
                                                      </Button>
                                                      <div style={{ display: 'flex', gap: '10px' }}>
                                                         <Button
                                                            variant="contained"
                                                            sx={{
                                                               backgroundColor: 'var(--brand-color)',
                                                               color: 'white',
                                                               fontSize: '12px',
                                                               textTransform: 'none',
                                                               cursor: 'pointer',
                                                               boxShadow: 'none',
                                                               padding: '2px 10px',
                                                               fontWeight: '500',
                                                               ':hover': {
                                                                  backgroundColor: 'var(--brand-color-hover)',
                                                                  boxShadow: 'none',
                                                               },
                                                            }}
                                                            onClick={() => {
                                                               navigator.clipboard.writeText(user_coupon['code']);
                                                               this.setState({
                                                                  isCodeCopied: true,
                                                                  copiedIndex: index,
                                                                  couponSuccess: true,
                                                                  successMsg: 'Code copied',
                                                               });
                                                            }}
                                                         >
                                                            {this.state.isCodeCopied && this.state.copiedIndex === index ? 'Copied!' : 'Copy Code'}
                                                         </Button>
                                                         <Button
                                                            variant="contained"
                                                            sx={{
                                                               backgroundColor: 'var(--brand-color)',
                                                               color: 'white',
                                                               fontSize: '12px',
                                                               cursor: 'pointer',
                                                               textTransform: 'none',
                                                               boxShadow: 'none',
                                                               padding: '2px 10px',
                                                               fontWeight: '500',
                                                               ':hover': {
                                                                  backgroundColor: 'var(--brand-color-hover)',
                                                                  boxShadow: 'none',
                                                               },
                                                            }}
                                                            onClick={() => {
                                                               navigator.clipboard.writeText(window.location.origin + '/subscribe?code=' + user_coupon['code']);
                                                               this.setState({
                                                                  isCodeCopied: true,
                                                                  copiedIndex: index,
                                                                  couponSuccess: true,
                                                                  successMsg: 'Link copied',
                                                               });
                                                            }}
                                                         >
                                                            Copy Link
                                                         </Button>
                                                      </div>
                                                   </Grid>
                                                </Grid>
                                             </AccordionDetails>
                                          </Accordion>
                                       </Grid>
                                    </Grid>
                                 );
                              })
                        ) : (
                           <div style={{
                              padding: '40px 0',
                              textAlign: 'center',
                              backgroundColor: '#fff',
                              width: '100%',
                              borderRadius: '8px',
                              border: '1px solid #E4EBF6',
                              marginBottom: '20px'
                           }}>
                              <PiMagnifyingGlass size={48} color="#9CA3B4" style={{ padding: '10px 0px' }} />
                              <h3 style={{
                                 marginTop: '8px',
                                 fontSize: '14px',
                                 fontWeight: '600',
                                 color: '#1D1D1D',
                                 fontFamily: 'Roboto, sans-serif'
                              }}>No Promotion Codes</h3>
                              <p style={{
                                 marginTop: '4px',
                                 fontSize: '14px',
                                 color: '#9CA3B4',
                                 fontFamily: 'Roboto, sans-serif'
                              }}>Get started by creating a new promotion code.</p>
                           </div>
                        )}
                        <TablePagination
                           component="div"
                           count={this.state.user_coupons.length}
                           page={this.state.page_num}
                           onPageChange={this.handleChangePage}
                           rowsPerPageOptions={[5]}
                           rowsPerPage={this.state.n_rows_per_page}
                        />
                     </Grid>
                  </Box>

               </Grid>
               <SnackbarAlert
                  msg={this.state.successMsg}
                  open={this.state.couponSuccess}
                  backgroundColor={'var(--brand-color)'}
                  severity={'success'}
                  handleClose={() => {
                     this.setState({
                        couponSuccess: false
                     })
                  }}
               />

               <Modal
                  disableAutoFocus={true}
                  sx={{
                     backgroundColor: 'rgba(0,0,0,0.47)',
                     borderRadius: '5px',
                     overflow: 'scroll',
                     minWidth: '100vw',
                     outline: '0',
                     display: 'flex',
                     zIndex: '1100',
                     lineHeight: '25px',
                     textAlign: 'center',
                     maxHeight: '100vh',
                     minHeight: '100vh',
                  }}
                  open={this.state.setCouponModal}
                  onClose={this.state.setCouponModal}
               >
                  <Grid sx={{
                     height: 'auto',
                     borderRadius: window.innerWidth <= 600 ? '0px' : '5px',
                     margin: 'auto',
                     textAlign: 'center',
                     display: 'flex'
                  }} xs={12} justifyContent='center' textAlign='center'>
                     <Grid container xs={12} alignItems="center" justifyContent="center" direction="column" style={{
                        width: '100%',
                        display: 'flex',
                        borderRadius: window.innerWidth <= 600 ? '0px' : '5px',
                     }}>
                        <Grid sx={{
                           width: '100vw',
                           maxWidth: '600px',
                           height: 'auto',
                           backgroundColor: '#fff',
                           borderRadius: window.innerWidth <= 600 ? '0px' : '10px',
                           margin: 'auto',
                           boxShadow: '0 5px 25px 0 rgba(35, 40, 105, 0.04)',
                           paddingTop: '5px',
                           paddingBottom: '20px',
                        }}>
                           <Grid item xs={6} style={{
                              top: '0px',
                              padding: '0px',
                              float: 'right',
                              paddingRight: '2%',
                              paddingTop: '2%',
                              textAlign: 'right',
                              flexBasis: '33%',
                           }}>
                              <IconButton style={{
                                 padding: '0px',
                                 margin: '0px',
                                 textAlign: 'right',
                                 color: '#9CA3B4',
                                 backgroundColor: 'transparent',
                                 justifyContent: 'right',
                                 minWidth: '30px',
                              }} onClick={() => {
                                 this.setState({ setCouponModal: false })
                                 this.props.setState({ isAnyModalOpen: false })
                              }}>
                                 <CloseIcon style={{
                                    fontSize: '30px',
                                    fontWeight: '300',
                                    textAlign: 'right',
                                    display: 'flex',
                                    position: 'absolute',
                                    padding: '0px',
                                 }} color='#9CA3B4' />
                              </IconButton>
                           </Grid>

                           <Grid container xs={12} style={{
                              padding: '0px',
                              height: '30px',
                              paddingTop: '20px',
                              borderRadius: '0px',
                              backgroundColor: '#fff',
                              borderTopLeftRadius: '5px',
                              borderTopRightRadius: '5px',
                              flexWrap: 'nowrap'
                           }}>
                              <Grid item xs={12} style={{ alignSelf: 'center', textAlign: 'center' }}>
                                 <Typography style={{
                                    color: 'black',
                                    fontSize: '18px',
                                    fontWeight: '600',
                                    textTransform: 'none',
                                    textAlign: 'center',
                                    cursor: 'default',
                                    backgroundColor: 'transparent',
                                 }}>Create New Promotion Code</Typography>
                              </Grid>
                           </Grid>

                           <Grid xs={12} style={{ padding: '20px', textAlign: 'center' }}>
                              <FormControl fullWidth hiddenLabel variant="filled" sx={{
                                 backgroundColor: '#fff',
                                 border: '0px',
                                 marginTop: '0px',
                                 borderRadius: '5px',
                                 display: 'block',
                                 textAlign: 'center',
                              }}>
                                 <p className="modal-title-text">Code (Optional)</p>
                                 <input type="text" id={"emailCaptureInput"} className={'text-input'} style={{
                                    display: 'block',
                                    fontWeight: '500',
                                    margin: '0px auto 15px auto',
                                    fontSize: '15px',
                                    padding: '10px 15px',
                                    color: '#1D1D1D',
                                    borderRadius: '5px',
                                    width: 'calc(100% - 30px)',
                                    fontFamily: 'Roboto',
                                    '&::placeholder': { color: 'red' }
                                 }} placeholder="Code" value={this.state.couponName} onChange={(event) => {
                                    const regex = /^((?!\_)[A-Za-z0-9])+$/;
                                    if (event.target.value.length === 0) {
                                       this.setState({ errorMsg: "", snackbar: false, couponName: event.target.value })
                                    } else if (regex.test(event.target.value) === false) {
                                       this.setState({ errorMsg: "Code can only contain numbers and letters with no spaces", snackbar: true })
                                    } else {
                                       this.setState({ errorMsg: "", snackbar: false, couponName: event.target.value })
                                    }
                                 }} />

                                 <p className="modal-title-text">Discount</p>
                                 <Box sx={{ width: '100%' }}>
                                    <FormControl fullWidth height={'16px'}>
                                       <Select sx={{ maxHeight: '42px', minHeight: '42px', zIndex: 99999 }}
                                          labelId="demo-simple-select-label"
                                          id="demo-simple-select"
                                          value={this.state.discountTierSelected}
                                          onChange={(event) => this.setState({ discountTierSelected: event.target.value })}>
                                          {this.state.discountTiers.map((item) => (
                                             <MenuItem value={item} sx={{ textAlign: 'center' }}>{item}%</MenuItem>
                                          ))}
                                       </Select>
                                    </FormControl>
                                 </Box>

                                 <p className="modal-title-text">Duration</p>
                                 <Box sx={{ width: '100%' }}>
                                    <FormControl fullWidth height={'16px'}>
                                       <Select sx={{ maxHeight: '42px', minHeight: '42px', zIndex: 99999 }}
                                          labelId="demo-simple-select-label"
                                          id="demo-simple-select"
                                          value={this.state.discountDurationSelected}
                                          onChange={(event) => this.setState({ discountDurationSelected: event.target.value })}>
                                          <MenuItem value={"1"} sx={{ textAlign: 'center' }}>{'1 Month'}</MenuItem>
                                          {this.state.discountDurationMonths.map((item) => (
                                             <MenuItem value={item} sx={{ textAlign: 'center' }}>{item} Months</MenuItem>
                                          ))}
                                       </Select>
                                    </FormControl>
                                 </Box>

                                 <p className="modal-title-text">Redeem Limit (optional)</p>
                                 <input type="number" id={"emailCaptureInput"} className={'text-input'} style={{
                                    display: 'block',
                                    fontWeight: '500',
                                    margin: '0px auto 15px auto',
                                    fontSize: '15px',
                                    padding: '10px 15px',
                                    color: '#1D1D1D',
                                    borderRadius: '5px',
                                    width: 'calc(100% - 30px)',
                                    fontFamily: 'Roboto',
                                    '&::placeholder': { color: 'red' }
                                 }} placeholder="Enter a number" value={this.state.couponLimit}
                                    onChange={(event) => this.setState({ couponLimit: event.target.value })} />

                                 <DateTimePicker isCentered={'true'} id="datetimepicker-1"
                                    placeholder={'Select Expiry Date (optional)'}
                                    value={this.state.dateTimeEnd}
                                    onChange={dateTimeEnd => this.setState({ dateTimeEnd })}
                                    formatStyle="small"
                                    style={{ textAlign: 'center', marginTop: '5px', marginBottom: '30px' }}
                                    okLabel={'Schedule'}
                                    cancelLabel={'Cancel'}
                                    icon={<FaCalendar style={{ color: 'var(--secondary-icon-color)' }} />} />

                                 <Button disableRipple fullWidth variant="contained" sx={{
                                    backgroundColor: 'var(--brand-color)',
                                    fontSize: '16px',
                                    marginTop: '0px',
                                    textTransform: 'none',
                                    marginBottom: '0px',
                                    borderRadius: '8px',
                                    boxShadow: 'none',
                                    fontWeight: '700',
                                    ':hover': {
                                       backgroundColor: 'var(--brand-color-hover)',
                                       color: 'white',
                                       boxShadow: 'none',
                                    },
                                 }} type="submit" value="new coupon" onClick={() => { this.NewCouponSubmit() }}>
                                    Create Promotion Code
                                 </Button>
                              </FormControl>
                           </Grid>
                        </Grid>
                     </Grid>

                     <SnackbarAlert msg={this.state.errorMsg} open={this.state.snackbar}
                        snackbarBackgroundColor={'var(--danger-color)'}
                        severity={'error'}
                        handleClose={() => { this.setState({ snackbar: false }) }} />
                  </Grid>
               </Modal>
            </div>
         )

      }


   }
}

export default Coupons;